import { render, staticRenderFns } from "./Payers.vue?vue&type=template&id=366a238a&"
import script from "./Payers.vue?vue&type=script&lang=js&"
export * from "./Payers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports